(function () {
  var mobileMq = window.matchMedia('(max-width: 989px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Below 990px every section drops its pinned scroll sequence, so each block
     gets scroll-linked motion here instead.
       y / x   travel in px before the block settles
       blur    softness before it settles
       alt     alternate x direction per item, for stacked rows
       img     child image that drifts inside the frame, with its cover zoom */
  var groups = [
    { selector: '.skn-our-why__figure', media: true, img: '.skn-our-why__image', zoom: 1.14 },
    { selector: '.skn-our-why__panel', y: 44, blur: 4 },
    { selector: '.skn-our-why__persona', y: 36 },
    { selector: '.skn-our-why__formula-intro', y: 34 },
    { selector: '.skn-our-why__formula-chapter', y: 40, blur: 4 },
    { selector: '.skn-formula__intro', y: 34 },
    { selector: '.skn-formula__chapter', y: 40 },
    { selector: '.skn-ingredient-theatre__intro', y: 30 },
    { selector: '.skn-ingredient-theatre__tile', y: 18, x: 34, alt: true },
    { selector: '.skn-plain-facts__intro', y: 30 },
    { selector: '.skn-ritual__heading', y: 30 },
    { selector: '.skn-ritual__step', y: 30, x: -22 },
    { selector: '.skn-ritual__media', media: true, img: '.skn-ritual__media-image', zoom: 1.14 },
    { selector: '.skn-faq__heading', y: 28 },
    { selector: '.skn-faq__item', y: 20 },
    { selector: '.skn-product-cta__media', media: true, img: '.skn-product-cta__media-image', zoom: 1.12 },
    { selector: '.skn-product-cta__content', y: 34 },
    { selector: '.skn-story__heading', y: 30 }
  ];

  var items = [];
  var running = false;
  var frame = null;
  var heartbeat = null;

  function smoothstep(t) {
    return t * t * (3 - 2 * t);
  }

  function clamp01(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  }

  /* 0 while the block sits below the fold, 1 once it has risen into the
     comfortable reading band. Spread over ~45% of a viewport so the movement
     is visible for a good part of the swipe. */
  function arrival(rect, vh) {
    var start = vh * 0.98;
    var end = vh * 0.5;
    return smoothstep(clamp01((start - rect.top) / (start - end)));
  }

  function update() {
    frame = null;
    if (!items.length) return;

    var vh = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var rect = item.el.getBoundingClientRect();

      /* Park anything more than a screen away: settled once it is above the
         viewport, waiting while it is still below. */
      var p;
      if (rect.bottom < -vh) {
        p = 1;
      } else if (rect.top > vh * 2) {
        p = 0;
      } else {
        p = arrival(rect, vh);
      }

      if (p !== item.p) {
        item.p = p;
        item.el.style.setProperty('--skn-mm-p', p.toFixed(3));
      }

      if (!item.img) continue;

      /* Frame centre relative to viewport centre, mapped to a drift inside the
         frame. Travel is capped by the overscan the cover zoom provides, so the
         image never pulls away from an edge. */
      var centre = (rect.top + rect.height / 2 - vh / 2) / vh;
      var amplitude = Math.min((rect.height * (item.zoom - 1)) / 2 * 0.85, 34);
      var shift = -clamp01((centre + 1) / 2) * 2 * amplitude + amplitude;
      item.img.style.setProperty('--skn-mm-shift', shift.toFixed(1) + 'px');
    }
  }

  function onScroll() {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  }

  function settleAll() {
    items.forEach(function (item) {
      item.el.style.setProperty('--skn-mm-p', '1');
      if (item.img) item.img.style.removeProperty('--skn-mm-shift');
    });
  }

  function teardown() {
    if (frame) {
      window.cancelAnimationFrame(frame);
      frame = null;
    }
    if (heartbeat) {
      clearInterval(heartbeat);
      heartbeat = null;
    }

    items.forEach(function (item) {
      item.el.removeAttribute('data-skn-mm');
      item.el.removeAttribute('data-skn-mm-v');
      item.el.style.removeProperty('--skn-mm-p');
      item.el.style.removeProperty('--skn-mm-x');
      item.el.style.removeProperty('--skn-mm-y');
      item.el.style.removeProperty('--skn-mm-blur');
      if (item.img) {
        item.img.removeAttribute('data-skn-mm-img');
        item.img.removeAttribute('data-skn-mm-v');
        item.img.style.removeProperty('--skn-mm-shift');
        item.img.style.removeProperty('--skn-mm-zoom');
      }
    });
    items = [];
    running = false;
  }

  function collect() {
    groups.forEach(function (group) {
      var nodes = document.querySelectorAll(group.selector);

      Array.prototype.forEach.call(nodes, function (el, index) {
        var img = group.img ? el.querySelector(group.img) : null;

        el.setAttribute('data-skn-mm', group.media ? 'media' : 'text');
        el.setAttribute('data-skn-mm-v', '');
        if (group.y != null) el.style.setProperty('--skn-mm-y', group.y + 'px');
        if (group.blur != null) el.style.setProperty('--skn-mm-blur', group.blur + 'px');

        if (group.x != null) {
          var x = group.alt && index % 2 ? -group.x : group.x;
          el.style.setProperty('--skn-mm-x', x + 'px');
        }

        var zoom = group.zoom || 1.12;
        if (img) {
          img.setAttribute('data-skn-mm-img', '');
          img.setAttribute('data-skn-mm-v', '');
          img.style.setProperty('--skn-mm-zoom', String(zoom));
        }

        items.push({ el: el, img: img, zoom: zoom, p: -1 });
      });
    });
  }

  /* Blocks above the current scroll position rest settled, blocks below rest
     hidden, so entering from either direction animates. */
  function rest(el) {
    return el.getBoundingClientRect().top < 0 ? '1' : '0';
  }

  function setup() {
    teardown();

    if (!mobileMq.matches || reduced) return;

    try {
      collect();
    } catch (error) {
      settleAll();
      return;
    }

    if (!items.length) return;

    running = true;
    update();

    /* Keeps running when scroll events are coalesced or frames are withheld,
       and re-measures after lazy images and fonts shift the layout. */
    heartbeat = setInterval(function () {
      if (!running) return;
      update();
    }, 400);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('orientationchange', onScroll, { passive: true });
  window.addEventListener('load', onScroll);
  window.addEventListener('pageshow', onScroll);
  window.addEventListener('beforeprint', settleAll);

  window.addEventListener('error', function () {
    if (running) settleAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  if (mobileMq.addEventListener) {
    mobileMq.addEventListener('change', setup);
  } else if (mobileMq.addListener) {
    mobileMq.addListener(setup);
  }

  document.addEventListener('shopify:section:load', setup);
})();
